import React, { useEffect } from "react";

const Comment = () => {
  useEffect(() => {
    window.VUUKLE_CONFIG = {
      apiKey: "24418bf6-f990-49df-a1ba-63fc48b54978",
      articleId: "https://pages.malaysiakini.com/budget2020/zh/poll/",
		"emotes": {
			"firstName": "开心",
			"secondName": "无动于衷",
			"thirdName": "逗乐了",
			"fourthName": "兴奋不已",
			"fifthName": "愤怒",
			"sixthName": "伤心"
		}
    };

    (function() {
      let d = document,
        s = d.createElement("script");
      s.src = "https://cdn.vuukle.com/platform.js";
      (d.head || d.body).appendChild(s);
    })();
  }, []);

  return (
    <div>
      <section className="uk-section uk-section-muted">
        <div className="uk-container uk-container-small uk-light">
          <div id="vuukle-emote" class="uk-margin"></div>
          <div id="vuukle-comments" className="uk-margin"></div>
        </div>
      </section>
    </div>
  );
};

export default Comment;
